import React from 'react';

import '../editStudyModal.scss';
import '../AttachCapToSchedule/attachCap.scss';
import Strings from '../../Strings';
import { SelectedOptions } from '../../components/Select/Multiselect';
import AsyncSelect from '../../components/Select/AsyncSelect';
import { SelectField } from '../../containers/Form';

function DeviceList(props) {
  const label = props.label || Strings.attachDevicesToKit;

  return (
    <>
      {props.asyncNeeded ? (
        <div className="row">
          <label>{label}</label>
          <AsyncSelect
            key={`device-list-${props.devices?.length || 0}`}
            placeholder={Strings.patient_medications.enter3Chars}
            loadOptions={props.loadOptions}
            defaultOptions={props.data}
            onChange={props.handleChange}
            isRequired={props.isRequired}
            highlightInvalid={props.highlightInvalid}
          />
        </div>
      ) : (
        <SelectField
          name="devices"
          id="devices"
          label={label}
          key={`device-list-${props.devices?.length || 0}`}
          placeholder={Strings.select}
          onChange={props.handleChange}
          data={props.data}
          isSearchable
          isRequired={props.isRequired}
          highlightInvalid={props.highlightInvalid}
        />
      )}
      <SelectedOptions items={props.devices} onRemove={props.delete} itemsPerRow={1} />
    </>
  );
};

export default DeviceList;
